import type { BlogPost } from "./blog";

export const BLOG_BIRTHDAY_PART5: BlogPost[] = [
  {
    "slug": "den-rozhdeniya-belye-nochi-peterburg",
    "title": "День рождения в белые ночи Петербурга: незабываемый формат",
    "metaTitle": "День рождения в белые ночи Петербурга | Паруса на крыше",
    "metaDescription": "Как отметить день рождения в белые ночи в Санкт-Петербурге. Терраса, вид на освещённый город, живая музыка. Скидка 20% именинникам.",
    "keywords": "день рождения белые ночи петербург, праздник белые ночи спб, июнь июль день рождения ресторан",
    "date": "2026-06-30",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_summer.webp",
    "lead": "Белые ночи Петербурга — явление, ради которого приезжают из всего мира. День рождения в это время — подарок, который нельзя купить. Он просто случается, если вы живёте здесь или приехали вовремя.",
    "sections": [
      {
        "heading": "Что такое белые ночи для праздника",
        "body": "С конца мая по середину июля в Петербурге не темнеет по-настоящему. В 23:00 всё ещё светло. Закат тянется часами. Терраса «Парусов» в это время — в пиковой популярности. Вид на Петербург в белую ночь с 6-го этажа — один из лучших видов в городе. День рождения здесь в июне — это подарок от природы.",
        "list": [
          "Белые ночи: конец мая — середина июля",
          "В 23:00 всё ещё светло",
          "Терраса открыта в хорошую погоду",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Терраса в белую ночь",
        "body": "Летняя терраса «Парусов» открывается в мае. В белые ночи — это место, куда хочется приходить снова и снова. Ужин на свежем воздухе с видом на Казанский собор в полночь, когда ещё светло — это опыт, который объяснить невозможно, его нужно прожить.",
        "highlight": "Терраса «Парусов» в белую ночь — самый популярный столик в городе. Бронируйте за 2–3 недели в июне-июле."
      },
      {
        "heading": "Как забронировать",
        "body": "В июне-июле бронируйте за 2–3 недели. Попросите место на террасе. Если погода не позволит — план Б: стол у панорамного окна с тем же видом. +7 (812) 991-10-90.",
        "list": [
          "Бронируйте за 2–3 недели",
          "Просите место на террасе",
          "План Б: панорамные окна",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать в белые ночи", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-8-marta-restoran-spb",
    "title": "День рождения 8 Марта в Петербурге: двойной праздник",
    "metaTitle": "День рождения 8 Марта в Петербурге | Паруса на крыше",
    "metaDescription": "Как отметить день рождения 8 Марта в Санкт-Петербурге. Двойной праздник, живая музыка, скидка 20% именинницам.",
    "keywords": "день рождения 8 марта петербург, праздник 8 марта день рождения, именинница 8 марта ресторан",
    "date": "2026-06-30",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "День рождения 8 Марта — двойной праздник для именинниц. Весь мир поздравляет всех женщин — но особенно тебя. Как отметить это по-настоящему?",
    "sections": [
      {
        "heading": "8 Марта — день именинницы в квадрате",
        "body": "Женщина с днём рождения 8 Марта получает двойные поздравления — от всего мира и лично. Праздник должен быть на уровне: «Паруса на крыше» в этот день работают с особой программой — специальное меню, живая музыка, праздничный декор. Скидка 20% именинницам + атмосфера 8-го марта.",
        "list": [
          "8 Марта в «Парусах»: особая программа",
          "Живая музыка",
          "Скидка 20% именинницам",
          "Букет цветов — принесите сами"
        ]
      },
      {
        "heading": "Как не потеряться в общем потоке",
        "body": "8 Марта — один из самых загруженных дней в ресторанах. Опасность: ваш именной праздник растворится в общей суете. Выход: скажите о дне рождения при бронировании, приходите пораньше, попросите лучший стол. Команда «Парусов» умеет выделить именинника среди общего праздника.",
        "highlight": "8 Марта — это не конкуренция с другими женщинами. Это ваш день рождения, который совпал с праздником. Вы важнее."
      },
      {
        "heading": "Бронирование",
        "body": "8 Марта бронируйте за 3–4 недели. Скажите о дне рождения. +7 (812) 991-10-90.",
        "list": [
          "Бронируйте за 3–4 недели",
          "Скажите о дне рождения",
          "Скидка 20% именинницам",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать 8 Марта", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-23-fevralya-restoran-spb",
    "title": "День рождения 23 Февраля в Петербурге: мужской праздник вдвойне",
    "metaTitle": "День рождения 23 Февраля в Петербурге | Паруса на крыше",
    "metaDescription": "Отметить день рождения 23 Февраля в Санкт-Петербурге. Двойной праздник для мужчин. Скидка 20% именинникам.",
    "keywords": "день рождения 23 февраля петербург, именинник 23 февраля ресторан, мужской праздник февраль",
    "date": "2026-07-01",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Именинник 23 Февраля — человек с двойным праздником. Весь мужской мир поздравляет, но ты — особенный. Как не дать дню рождения раствориться в общем поздравлении?",
    "sections": [
      {
        "heading": "23 Февраля — двойной праздник",
        "body": "Мужчины с днём рождения 23 Февраля часто жалуются: «День рождения не отличить от праздника». Выход — сделать его очевидно личным: скидка 20% именинникам в «Парусах», именной торт, живая музыка в нужный момент. Ваш день рождения — ваш. Даже если все вокруг тоже именинники.",
        "list": [
          "23 Февраля в «Парусах»: особая программа",
          "Именной торт — отличает ваш праздник",
          "Скидка 20% именинникам",
          "Живая музыка по расписанию"
        ]
      },
      {
        "heading": "Мужской праздник в ресторане",
        "body": "Хороший стейк, правильное вино, вид на Петербург. Это то, что нужно мужскому дню рождения 23 Февраля. В «Парусах» это стандарт. Никакой суеты, никаких «корпоративных поздравлений» — только ваш вечер.",
        "highlight": "23 Февраля в «Парусах» — ваш личный праздник, который совпал с днём мужчин. Приходите отмечать себя."
      },
      {
        "heading": "Бронирование",
        "body": "23 Февраля бронируйте за 2–3 недели. +7 (812) 991-10-90. Скидка 20% именинникам.",
        "list": [
          "Бронируйте за 2–3 недели",
          "+7 (812) 991-10-90",
          "Скидка 20% именинникам",
          "Именной торт под заказ"
        ]
      }
    ],
    "cta": { "text": "Забронировать 23 Февраля", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-novogodniy-sezon-spb",
    "title": "День рождения в новогодний сезон в Петербурге: как не потеряться",
    "metaTitle": "День рождения в новогодний сезон в СПб | Паруса на крыше",
    "metaDescription": "Как отметить день рождения в декабре–январе в Санкт-Петербурге. Скидка 20% именинникам. Новогодняя атмосфера + личный праздник.",
    "keywords": "день рождения декабрь январь петербург, праздник новогодний сезон спб, именинник декабрь",
    "date": "2026-07-01",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Декабрьские и январские именинники знают проблему: день рождения теряется в новогодней суете. Все заняты, все торопятся, все «отмечают». Как выделиться?",
    "sections": [
      {
        "heading": "Декабрь и январь: особый контекст",
        "body": "В декабре все рестораны в праздничном декоре. Атмосфера помогает. Но конкуренция за внимание гостей высокая: корпоративы, новогодние вечеринки, семейные встречи. Ваш день рождения может раствориться. Решение: скажите всем заранее «это мой день рождения, не Новый год». И выберите место, которое это подчеркнёт.",
        "list": [
          "Декабрь: праздничная атмосфера помогает",
          "Конкуренция: бронируйте за 3–5 недель",
          "Именной торт отличает ваш праздник",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Как сделать декабрьский день рождения личным",
        "body": "Именной торт с вашим именем и датой — а не «С Новым годом». Живая музыка с вашей любимой мелодией. Стол у окна с видом на зимний Петербург в огнях — не корпоративный зал. В «Парусах» банкетный менеджер помогает создать личный праздник в разгар новогоднего сезона.",
        "highlight": "Именной торт в «Парусах» в декабре: «С Днём рождения, [Ваше имя]» — а не елочки и снежинки. Это ваш праздник, не Новый год."
      },
      {
        "heading": "Практически",
        "body": "Декабрь: бронируйте за 3–5 недель. Январь (после 10-го): тише, можно за 1–2 недели. +7 (812) 991-10-90.",
        "list": [
          "Декабрь: за 3–5 недель",
          "Январь после 10-го: за 1–2 недели",
          "Именной торт — не новогодний",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать в новогодний сезон", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-subbota-restoran-spb",
    "title": "День рождения в субботу в Петербурге: лучший день для праздника",
    "metaTitle": "День рождения в субботу в Петербурге | Паруса на крыше",
    "metaDescription": "Почему суббота — лучший день для дня рождения в ресторане Санкт-Петербурга. Живая музыка, полная атмосфера. Скидка 20% именинникам.",
    "keywords": "день рождения суббота петербург, субботний праздник ресторан спб, забронировать субботу",
    "date": "2026-07-01",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "Суббота — идеальный день для дня рождения в ресторане. Гости свободны, никто не торопится, можно остаться допоздна. Живая музыка — в расписании. Всё совпало.",
    "sections": [
      {
        "heading": "Почему суббота лучше всего",
        "body": "Суббота: гости не думают о работе завтра, живая музыка в расписании, можно прийти в 19:00 и остаться до 23:00. Для большинства дней рождения — оптимальный день. В «Парусах» суббота — пиковый день. Бронируйте заранее — лучшие столики разбирают.",
        "list": [
          "Гости свободны и не торопятся",
          "Живая музыка — в субботу всегда",
          "Можно остаться допоздна",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Как забронировать субботу",
        "body": "Суббота в «Парусах» — самый загруженный день. Для камерного ужина (5–10 человек) — за 1–2 недели. Для банкета (20–50 человек) — за 3–4 недели. Для большого банкета (50+) — за 5–8 недель. Не откладывайте.",
        "highlight": "Хотите субботу в «Парусах» — бронируйте сейчас. Выходные расписаны далеко вперёд, особенно летом."
      },
      {
        "heading": "Контакты",
        "body": "+7 (812) 991-10-90. Ул. Марата, 5, 6-й этаж.",
        "list": [
          "+7 (812) 991-10-90",
          "Ул. Марата, 5, 6-й этаж",
          "Живая музыка по субботам",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Забронировать субботу", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-voskresenye-restoran-spb",
    "title": "День рождения в воскресенье в Петербурге: семейный день",
    "metaTitle": "День рождения в воскресенье в Петербурге | Паруса на крыше",
    "metaDescription": "День рождения в воскресенье в ресторане Санкт-Петербурга. Семейный формат, комфортный вечер. Скидка 20% именинникам.",
    "keywords": "день рождения воскресенье петербург, воскресный праздник ресторан спб, семейный ужин воскресенье",
    "date": "2026-07-01",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Воскресенье — день семейных обедов и ужинов. День рождения в воскресенье — это когда вся семья может собраться без спешки.",
    "sections": [
      {
        "heading": "Воскресенье для семейного праздника",
        "body": "Воскресенье немного спокойнее субботы в ресторанах — атмосфера более камерная. Живая музыка — в расписании (уточните при бронировании). Для семейных форматов воскресный обед или ранний ужин — лучший выбор. Все собираются без спешки, никто не думает о работе.",
        "list": [
          "Немного спокойнее субботы",
          "Семейный формат — органично",
          "Живая музыка — уточните расписание",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Воскресный обед vs ужин",
        "body": "Обед в 13:00–15:00: семьи с детьми, пожилые родственники, более расслабленный формат. Ужин в 18:00–20:00: более торжественно, вечерний вид. В «Парусах» оба варианта работают хорошо.",
        "highlight": "Воскресный обед на день рождения в «Парусах» — это когда бабушки и дедушки могут приехать без труда, а дети ещё не устали. Правильный тайминг."
      },
      {
        "heading": "Бронирование",
        "body": "Воскресенье: за 1–2 недели для обеда, за 2–3 недели для ужина. +7 (812) 991-10-90.",
        "list": [
          "Обед: за 1–2 недели",
          "Ужин: за 2–3 недели",
          "+7 (812) 991-10-90",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Забронировать воскресенье", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-pyatnitsa-restoran-spb",
    "title": "День рождения в пятницу в Петербурге: вечер после рабочей недели",
    "metaTitle": "День рождения в пятницу в Петербурге | Паруса на крыше",
    "metaDescription": "День рождения в пятницу в ресторане Санкт-Петербурга. Живая музыка, атмосфера. Скидка 20% именинникам. Ул. Марата 5.",
    "keywords": "день рождения пятница петербург, пятничный праздник ресторан спб, отметить в пятницу",
    "date": "2026-07-01",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "Пятница — лучший день рождения во многих смыслах. Рабочая неделя закончена, гости расслаблены, живая музыка в расписании, можно остаться допоздна.",
    "sections": [
      {
        "heading": "Почему пятница — хорошо",
        "body": "Пятница: рабочая неделя позади, у всех хорошее настроение, никто не торопится. Живая музыка в расписании. Вечер может продолжаться до 23:00–00:00 — завтра выходной. Для большинства дней рождения это идеальный контекст.",
        "list": [
          "Рабочая неделя позади",
          "Живая музыка по пятницам",
          "Можно остаться допоздна",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Пятничная атмосфера в «Парусах»",
        "body": "Пятница в «Парусах» — живая и насыщенная. Город в приподнятом настроении, ресторан полон, музыка правильная. Именно в пятницу день рождения ощущается как настоящий праздник — не только для вас, но и для всего ресторана.",
        "highlight": "Пятничный день рождения в «Парусах» — это когда атмосфера города совпадает с атмосферой вашего вечера. Это редкое совпадение."
      },
      {
        "heading": "Бронирование",
        "body": "Пятница: за 1–2 недели. Летом — за 2–3 недели. +7 (812) 991-10-90.",
        "list": [
          "За 1–2 недели",
          "Летом: за 2–3 недели",
          "+7 (812) 991-10-90",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Забронировать пятницу", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "pervyy-den-rozhdeniya-malysha-restoran",
    "title": "Первый день рождения малыша в ресторане Петербурга",
    "metaTitle": "Первый день рождения ребёнка в ресторане СПб | Паруса",
    "metaDescription": "Как отметить первый день рождения малыша в ресторане Санкт-Петербурга. Детское меню, торт, семейная атмосфера. Скидка 20% именинникам.",
    "keywords": "первый день рождения год ресторан петербург, 1 год день рождения ресторан спб, малыш 1 год праздник",
    "date": "2026-07-02",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Первый день рождения — праздник для родителей. Малышу год, он ничего не поймёт. Но вы поймёте. И гости поймут. Выберите место, которое соответствует этому моменту.",
    "sections": [
      {
        "heading": "Первый день рождения: для кого этот праздник",
        "body": "Первый год жизни — это подвиг для родителей. Первый ДР — это их праздник, а не малыша. Поэтому выбирайте место, которое понравится вам: красивое, с видом, с хорошей кухней. Малыш запомнит только торт на фото.",
        "list": [
          "Первый год — победа родителей",
          "Торт с одной свечой — для фото",
          "Семейная атмосфера",
          "Скидка 20% именинникам (малышу)"
        ]
      },
      {
        "heading": "Как организовать",
        "body": "Небольшая семейная компания: 8–15 человек. Ранний вечер (17:00). Торт с одной свечой. Детский стульчик. Место у края зала (удобно выйти). В «Парусах» всё это возможно — скажите при бронировании.",
        "highlight": "Фото малыша с первым тортом на фоне Петербурга — это фото, которое останется в семейном архиве навсегда. Выбирайте место достойно этого момента."
      },
      {
        "heading": "Организация",
        "body": "За 1–2 недели: +7 (812) 991-10-90. Скажите о малыше. Детский стульчик по запросу.",
        "list": [
          "За 1–2 недели",
          "+7 (812) 991-10-90",
          "Детский стульчик по запросу",
          "Ранний вечер 17:00"
        ]
      }
    ],
    "cta": { "text": "Забронировать первый день рождения", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-interesnye-idei-spb",
    "title": "Интересные идеи для дня рождения в Петербурге: нестандартный подход",
    "metaTitle": "Интересные идеи для дня рождения в Петербурге | Паруса",
    "metaDescription": "Интересные и необычные идеи для дня рождения в Санкт-Петербурге. Нестандартный подход к праздникам. Скидка 20% именинникам.",
    "keywords": "интересные идеи день рождения петербург, нестандартный праздник спб, необычный день рождения",
    "date": "2026-07-02",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Хочется что-то нестандартное? Не просто «пришли-поели-ушли»? Разбираем идеи, которые работают в Петербурге.",
    "sections": [
      {
        "heading": "Идеи, которые работают",
        "body": "Ужин с дегустацией вин: сомелье выбирает 5 вин к 5 блюдам. Бранч-день рождения: утром в выходной, расслабленно и светло. Праздник с живым художником: он рисует именинника или компанию за ужином. Ужин с видом на закат: бронируйте за 2 часа до заката. День рождения в два акта: ужин + прогулка по ночному Петербургу.",
        "list": [
          "Дегустация вин с сомелье",
          "Бранч-день рождения (воскресенье, 12:00)",
          "Ужин под закат (летом)",
          "Два акта: ужин + прогулка"
        ]
      },
      {
        "heading": "Нестандартный формат в «Парусах»",
        "body": "«Паруса» — место, которое хорошо работает для нестандартных форматов. Дегустационный сет можно организовать при предварительном звонке. Сомелье помогает с вином. Бранч в выходной — доступен. Говорите о своих идеях менеджеру — постараемся реализовать.",
        "highlight": "Нестандартный день рождения — это не сложно. Это просто другой разговор при бронировании: «Хочу что-то необычное». Мы расскажем, что возможно."
      },
      {
        "heading": "Обсудите идею",
        "body": "+7 (812) 991-10-90. Расскажите о вашей идее. Постараемся реализовать. Скидка 20% именинникам.",
        "list": [
          "+7 (812) 991-10-90",
          "Расскажите о вашей идее",
          "Постараемся реализовать",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Обсудить нестандартный праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "kreativnyy-den-rozhdeniya-spb-idei",
    "title": "Креативный день рождения в Петербурге: идеи для творческих людей",
    "metaTitle": "Креативный день рождения в Петербурге | Паруса на крыше",
    "metaDescription": "Идеи креативного дня рождения в Санкт-Петербурге для творческих людей. Арт-вечер, живой художник, нестандартные форматы.",
    "keywords": "креативный день рождения петербург, арт день рождения спб, творческий праздник ресторан",
    "date": "2026-07-02",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Творческие люди не хотят «стандартного банкета». Они хотят вечер с характером, атмосферой и воспоминаниями. Разбираем, как устроить арт-день рождения.",
    "sections": [
      {
        "heading": "Арт-вечер в ресторане",
        "body": "Для творческих людей хорошо работает: живой художник во время ужина (рисует портреты гостей или пишет натюрморт с видом), музыкант с нестандартным репертуаром (джаз, акустика, классика), кулинарный мастер-класс до или после ужина, поэтические чтения между блюдами. Всё это реализуемо — часть организуется через «Паруса», часть вы берёте сам.",
        "list": [
          "Живой художник — организуйте сами",
          "Музыкант с особым репертуаром — согласуйте",
          "Кулинарный класс — уточните возможность",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Место как произведение искусства",
        "body": "Для творческого человека место — это уже высказывание. «Паруса на крыше» с видом на архитектуру Петербурга — это ресторан, который сам по себе художественный объект. Панорама исторического центра — это инсталляция, которую не создашь в никаком арт-пространстве.",
        "highlight": "Творческий человек оценит: место с видом говорит само. Никаких объяснений, никаких «это концепция». Просто открываешь окно — и вот Петербург."
      },
      {
        "heading": "Контакт",
        "body": "+7 (812) 991-10-90. Расскажите о вашей идее. Скидка 20% именинникам.",
        "list": [
          "+7 (812) 991-10-90",
          "Расскажите об идее",
          "Согласуем что возможно",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Обсудить творческий вечер", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "gde-otmetit-dr-peterburg-okonchatelniy-gid",
    "title": "Где отметить день рождения в Петербурге: окончательный гид 2026",
    "metaTitle": "Где отметить день рождения в Петербурге 2026 — гид | Паруса",
    "metaDescription": "Полный гид по выбору места для дня рождения в Санкт-Петербурге 2026. Критерии, варианты, лучший выбор. Скидка 20% именинникам в «Парусах».",
    "keywords": "где отметить день рождения петербург 2026, лучший ресторан день рождения спб, гид праздник петербург",
    "date": "2026-07-02",
    "category": "День рождения в Петербурге",
    "readTime": 8,
    "image": "/photos/view_day.webp",
    "lead": "Хотите один ответ на вопрос «где отметить день рождения в Петербурге»? Он ниже. Но сначала — логика выбора, потому что «правильное место» зависит от того, что важно именно вам.",
    "sections": [
      {
        "heading": "Как выбрать место по критериям",
        "body": "Задайте себе три вопроса. Первый: сколько гостей? (Камерный ужин или большой банкет — разные места). Второй: что важнее — атмосфера или кухня? (Или и то, и другое). Третий: какой бюджет на человека? (Это определяет класс ресторана). Ответы сузят выбор в разы.",
        "list": [
          "Сколько гостей: 5–15, 15–50, 50+",
          "Что важнее: атмосфера, кухня, оба",
          "Бюджет: средний чек на человека",
          "Сезон: лето (терраса) или зима (интерьер)"
        ]
      },
      {
        "heading": "Почему «Паруса» — для большинства вариантов",
        "body": "«Паруса на крыше» работают для очень разных форматов: камерный ужин на 5 человек и банкет на 200 — оба возможны. Все сезоны. Все возрасты. Все поводы. Панорамный вид на Петербург нравится всем без исключения. Авторская кухня достаточно разнообразна. Живая музыка включена.",
        "highlight": "«Паруса» — ресторан, который работает для дня рождения 25-летней девушки и 70-летнего юбиляра одинаково хорошо. Вид объединяет."
      },
      {
        "heading": "Финальные рекомендации",
        "body": "Если вы прочитали всё это и ещё думаете — просто позвоните: +7 (812) 991-10-90. Расскажите о своём дне рождения: дата, количество гостей, пожелания. Менеджер скажет, что возможно. Скидка 20% именинникам — 7 дней до и после ДР. Ул. Марата, 5, Olympic Plaza, 6-й этаж. Работаем с 2009 года.",
        "list": [
          "+7 (812) 991-10-90",
          "Ул. Марата, 5, Olympic Plaza, 6-й этаж",
          "Скидка 20% — 7 дней до и после ДР",
          "Работаем с 2009 года, рейтинг 5,0"
        ]
      }
    ],
    "cta": { "text": "Забронировать день рождения", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-posle-raboty-restoran-spb",
    "title": "День рождения после работы в Петербурге: быстро организовать",
    "metaTitle": "День рождения после работы в Петербурге | Паруса на крыше",
    "metaDescription": "Как организовать день рождения после работы в Санкт-Петербурге. Ресторан рядом с центром. Скидка 20% именинникам.",
    "keywords": "день рождения после работы петербург, вечер день рождения спб, праздник вечером центр",
    "date": "2026-07-02",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "«Давайте соберёмся после работы на мой день рождения» — один из самых частых сценариев. Никакой лишней организации: просто хороший ресторан в центре, куда удобно добраться.",
    "sections": [
      {
        "heading": "Удобное расположение для рабочей компании",
        "body": "«Паруса» — ул. Марата, 5, 5 минут пешком от метро Маяковская. Большинство центральных офисов в Петербурге — в пешей доступности или одной остановке метро. После работы: приехать, заказать, поужинать. Средний чек ~1 300 ₽/чел — это разумно для рабочего праздника.",
        "list": [
          "Ул. Марата, 5 — центр",
          "5 мин от метро Маяковская",
          "Средний чек ~1 300 ₽/чел",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Как организовать за час",
        "body": "В рабочий день: позвоните в 12:00 — +7 (812) 991-10-90. Скажите «нас будет 8 человек, сегодня вечером, день рождения». В будни свободных мест больше. Скидка 20% именинникам — без предварительного заказа, просто скажите при оплате.",
        "highlight": "День рождения после работы — это иногда самые живые и настоящие вечера. Никакой помпезности. Просто люди, которые рады друг другу."
      },
      {
        "heading": "Контакты",
        "body": "+7 (812) 991-10-90. Ул. Марата, 5, 6-й этаж.",
        "list": [
          "+7 (812) 991-10-90",
          "Ул. Марата, 5, 6-й этаж",
          "Скидка 20% именинникам",
          "Будни: больше свободных мест"
        ]
      }
    ],
    "cta": { "text": "Позвонить и забронировать сегодня", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-s-proshaniyem-leto-spb",
    "title": "День рождения как прощание с летом в Петербурге: сентябрь",
    "metaTitle": "День рождения в конце лета в Петербурге | Паруса на крыше",
    "metaDescription": "День рождения в конце лета (август-сентябрь) в Санкт-Петербурге. Прощание с летом за ужином с видом. Скидка 20% именинникам.",
    "keywords": "день рождения конец лета петербург, август сентябрь день рождения спб, прощание летом ресторан",
    "date": "2026-07-03",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_summer.webp",
    "lead": "Конец августа — начало сентября в Петербурге. Ещё тепло, ещё светло, но уже чувствуется осень. День рождения в это время — прощание с летом и встреча нового года жизни.",
    "sections": [
      {
        "heading": "Особая красота сентябрьского Петербурга",
        "body": "Август-сентябрь в Петербурге — самое красивое время года для многих. Первые жёлтые листья. Тепло и уют одновременно. Виды с 6-го этажа «Парусов» в этот период особенные: золотистый свет, красивые кроны деревьев, ещё не серое небо.",
        "list": [
          "Золотистый свет августа-сентября",
          "Терраса ещё открыта в хорошую погоду",
          "Грибной сезон: лисички в меню",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Что особенного в меню",
        "body": "Конец лета — начало грибного сезона. Лисички, белые грибы, маслята. В «Парусах» сезонное меню отражает это: грибные блюда, дичь, последние летние овощи. Идеальный момент для ужина с историей.",
        "highlight": "Лисички в августе-сентябре — лучшие в году. День рождения с тарелкой лисичек от шефа и видом на золотой Петербург — это осень в лучшем виде."
      },
      {
        "heading": "Бронирование",
        "body": "Август: бронируйте за 1–2 недели. Сентябрь: 3–5 дней обычно достаточно. +7 (812) 991-10-90.",
        "list": [
          "Август: за 1–2 недели",
          "Сентябрь: за 3–5 дней",
          "+7 (812) 991-10-90",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Забронировать осенний праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "nestandartnyy-dr-peterburg-restoran",
    "title": "Нестандартный день рождения в Петербурге: выйди за рамки",
    "metaTitle": "Нестандартный день рождения в Петербурге | Паруса на крыше",
    "metaDescription": "Нестандартный день рождения в Санкт-Петербурге: идеи, форматы, места. Скидка 20% именинникам в «Парусах на крыше».",
    "keywords": "нестандартный день рождения петербург, необычный праздник спб, оригинальный день рождения",
    "date": "2026-07-03",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "«Надоело одно и то же». Это нормально. Каждый год нужно что-то новое. Разбираем, как сделать день рождения нестандартным, не усложняя.",
    "sections": [
      {
        "heading": "Что значит нестандартный",
        "body": "Нестандартный — не значит дорого или сложно. Нестандартный — значит запоминающийся. Можно сменить время (утренний бранч вместо вечернего ужина). Можно сменить формат (дегустация вин вместо обычного меню). Можно сменить размер компании (только 5 самых близких вместо 30). Любое из этого уже делает вечер другим.",
        "list": [
          "Другое время: утренний бранч",
          "Другой формат: дегустация",
          "Другой размер: только 5 человек",
          "Другой день: будний вместо выходного"
        ]
      },
      {
        "heading": "Нестандартные идеи в «Парусах»",
        "body": "Ужин на рассвете (летом рассвет в 4:00 — если ресторан работает). Дегустационный сет от шефа вместо обычного меню. Только вы двое с видом на ночной Петербург. Праздник в будний день, когда никто не ожидает. Все эти форматы обсудите при бронировании.",
        "highlight": "Нестандартный день рождения — это не экстравагантность. Это осознанный выбор того, что важно именно вам."
      },
      {
        "heading": "Как реализовать",
        "body": "+7 (812) 991-10-90. Расскажите об идее. Скидка 20% именинникам.",
        "list": [
          "+7 (812) 991-10-90",
          "Расскажите об идее",
          "Скидка 20% именинникам",
          "Постараемся реализовать"
        ]
      }
    ],
    "cta": { "text": "Обсудить нестандартный вечер", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-korporativnyy-podgotovka-spb",
    "title": "Корпоративный день рождения: как подготовиться за 3 дня",
    "metaTitle": "Корпоративный день рождения за 3 дня в СПб | Паруса",
    "metaDescription": "Как организовать корпоративный день рождения за 3 дня в Санкт-Петербурге. Быстрое бронирование в «Парусах». Скидка 20% именинникам.",
    "keywords": "корпоративный день рождения срочно петербург, быстро организовать праздник спб, кратко подготовиться ресторан",
    "date": "2026-07-03",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Вспомнили о дне рождения коллеги за 3 дня? Без паники. Разбираем, что реально успеть.",
    "sections": [
      {
        "heading": "За 3 дня: реалистичный план",
        "body": "День 1: позвоните в «Паруса» (+7 (812) 991-10-90), забронируйте стол на [дата], [количество]. Скажите о дне рождения. Напишите коллегам — «приходим в Паруса в [время]». День 2: закажите торт (если нужен — за 3 дня возможно, уточните). День 3: приходите.",
        "list": [
          "День 1: бронирование + приглашения",
          "День 2: торт под заказ (если нужен)",
          "День 3: прийти и праздновать",
          "Скидка 20% имениннику"
        ]
      },
      {
        "heading": "Что не успеть за 3 дня — и это нормально",
        "body": "За 3 дня не успеть: большой банкет с программой (это требует 2–3 недели), флористическое оформление, ведущего. Но: стол у окна с видом на Петербург, живая музыка, хороший ужин и торт с именем — всё это реально. И это достаточно для хорошего вечера.",
        "highlight": "3 дня — достаточно для хорошего корпоративного дня рождения в «Парусах». Всё самое важное реально организовать за это время."
      },
      {
        "heading": "Контакты",
        "body": "+7 (812) 991-10-90. Скажите дату и количество. Скидка 20% имениннику.",
        "list": [
          "+7 (812) 991-10-90",
          "Скажите дату и количество",
          "Скидка 20% имениннику",
          "Торт за 3 дня — уточните возможность"
        ]
      }
    ],
    "cta": { "text": "Забронировать срочно", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "yubiley-papy-restoran-peterburg",
    "title": "Юбилей папы в Петербурге: как устроить ему достойный праздник",
    "metaTitle": "Юбилей папы в Петербурге — ресторан | Паруса на крыше",
    "metaDescription": "Как организовать юбилей папы в Санкт-Петербурге. Ресторан с хорошей кухней и видом. Скидка 20% именинникам.",
    "keywords": "юбилей папы петербург ресторан, день рождения отца спб, праздник для папы",
    "date": "2026-07-03",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Папин юбилей — момент, когда дети говорят «спасибо» на языке поступков. Выбрать для него лучшее место — это именно такой поступок.",
    "sections": [
      {
        "heading": "Что важно папе",
        "body": "Папы ценят: хорошую еду (мясо, рыба — классика), правильный алкоголь (вино, виски — уточните при заказе), красивое место, которое не нужно объяснять. «Паруса» идеально подходят: вид на Петербург, стейки, вино, живая музыка. Всё в одном месте.",
        "list": [
          "Хорошее мясо и рыба",
          "Правильный алкоголь",
          "Красивый вид — сам говорит",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Сюрприз или совместный выбор",
        "body": "Многие папы говорят «не надо ничего». Но прийти в «Паруса» и увидеть Петербург с 6-го этажа — это меняет мнение. Организуйте сюрприз или скажите заранее. Оба варианта работают.",
        "highlight": "Когда папа видит Петербург с 6-го этажа — он не говорит «не надо было». Это место, которое оправдывает любой повод."
      },
      {
        "heading": "Организация",
        "body": "За 1–3 недели: +7 (812) 991-10-90. Скажите «юбилей папы, [дата], [количество гостей]». Скидка 20% папе-имениннику.",
        "list": [
          "За 1–3 недели",
          "+7 (812) 991-10-90",
          "Скажите о юбилее папы",
          "Скидка 20% имениннику"
        ]
      }
    ],
    "cta": { "text": "Забронировать для папы", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-rebenka-shkola-restoran",
    "title": "День рождения ребёнка-школьника в ресторане Петербурга",
    "metaTitle": "День рождения школьника в ресторане СПб | Паруса на крыше",
    "metaDescription": "День рождения ребёнка 8–14 лет в ресторане Санкт-Петербурга. Атмосфера, торт, вид. Скидка 20% именинникам.",
    "keywords": "день рождения школьник ресторан петербург, ребёнок 8 9 10 11 12 13 14 лет день рождения спб",
    "date": "2026-07-03",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "День рождения ребёнка-школьника — это уже не детский праздник, но ещё не взрослый. Особый возраст, который требует особого подхода.",
    "sections": [
      {
        "heading": "Школьник в ресторане: что работает",
        "body": "8–14 лет — возраст, когда дети уже хотят «как взрослые». Ресторан с панорамным видом — это «по-взрослому». Вид с 6-го этажа — первое впечатление, которое ребёнок запомнит. Живая музыка — необычно и интересно. Торт с любимой тематикой — детское удовольствие.",
        "list": [
          "Ощущение взрослости — дети ценят",
          "Вид с 6-го этажа — первый раз сверху",
          "Торт с тематикой ребёнка",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Формат для школьного возраста",
        "body": "Небольшая компания одноклассников или друзей: 8–15 человек. Ужин в 17:00–19:00. Торт с любимым персонажем (Minecraft, Роблокс, Марвел — обсудите с кондитером). Родители могут быть рядом или в стороне — в зависимости от возраста.",
        "highlight": "Первый раз в «настоящем» ресторане — это то, что ребёнок помнит. Сделайте этот первый раз с видом на Петербург."
      },
      {
        "heading": "Организация",
        "body": "За 1–2 недели: +7 (812) 991-10-90. Скажите возраст ребёнка. Торт под тематику — под заказ.",
        "list": [
          "За 1–2 недели",
          "+7 (812) 991-10-90",
          "Скажите возраст ребёнка",
          "Торт с тематикой под заказ"
        ]
      }
    ],
    "cta": { "text": "Забронировать для школьника", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-14-fevralya-restoran-spb",
    "title": "День рождения 14 февраля в Петербурге: влюблённость и именинник",
    "metaTitle": "День рождения 14 февраля в Петербурге | Паруса на крыше",
    "metaDescription": "День рождения в День влюблённых 14 февраля в Санкт-Петербурге. Двойной праздник. Скидка 20% именинникам. Живая музыка.",
    "keywords": "день рождения 14 февраля петербург, именинник день влюблённых спб, день рождения валентин",
    "date": "2026-07-04",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_sunset.webp",
    "lead": "14 февраля — самый романтичный день рождения в году. Весь мир говорит о любви, а ты ещё и именинник. Это двойной подарок судьбы.",
    "sections": [
      {
        "heading": "14 февраля: самый романтичный день рождения",
        "body": "Именинник 14 февраля — человек, у которого романтика удвоена. В «Парусах» в этот день: особая программа, живая музыка, праздничный декор, влюблённые пары повсюду — и ты главный герой среди всех. Скидка 20% именинникам — это не просто «день валентина», это ваш личный праздник.",
        "list": [
          "14 февраля: особая программа",
          "Живая музыка — в расписании",
          "Скидка 20% именинникам",
          "Романтический декор включён"
        ]
      },
      {
        "heading": "Как совместить день рождения и день влюблённых",
        "body": "Хорошая новость: вам не нужно выбирать. В «Парусах» оба праздника сочетаются органично. Именной торт с именем и датой 14/02 — и всё понятно. Шампанское к торту — романтика. Вид на вечерний Петербург — идеальный фон для обоих праздников.",
        "highlight": "Именинник 14 февраля получает скидку 20% на личный счёт ПЛЮС атмосферу самого романтичного дня года. Дважды победитель."
      },
      {
        "heading": "Бронирование",
        "body": "14 февраля — бронируйте за 3–4 недели. Очень загружен. +7 (812) 991-10-90.",
        "list": [
          "Бронируйте за 3–4 недели",
          "+7 (812) 991-10-90",
          "Скидка 20% именинникам",
          "Именной торт под заказ"
        ]
      }
    ],
    "cta": { "text": "Забронировать 14 февраля", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "den-rozhdeniya-cheloveka-bez-planov-spb",
    "title": "День рождения без планов: как отметить в Петербурге в последний момент",
    "metaTitle": "День рождения без планов в Петербурге | Паруса на крыше",
    "metaDescription": "Как отметить день рождения без планов в Санкт-Петербурге. Звоните в день события. Скидка 20% именинникам. Ул. Марата 5.",
    "keywords": "день рождения без планов петербург, срочно отметить день рождения спб, последний момент бронирование",
    "date": "2026-07-04",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Сегодня ваш день рождения — и вы только что решили его отметить. Это нормально. Вот что можно сделать прямо сейчас.",
    "sections": [
      {
        "heading": "День рождения сегодня — что реально",
        "body": "Позвоните прямо сейчас: +7 (812) 991-10-90. В будни свободных мест больше — часто получается в тот же день. В выходные — сложнее, но попробуйте позвонить. Для компании 2–5 человек шансы выше, чем для 15. Скажите «сегодня мой день рождения» — это открывает двери.",
        "list": [
          "+7 (812) 991-10-90 — прямо сейчас",
          "Будни: чаще есть места",
          "2–5 человек: выше шансы",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Что можно успеть",
        "body": "За несколько часов: забронировать стол, договориться о десерте с поздравлением (не торт на заказ, но десерт от кухни — возможно). Пригласить нескольких человек. Этого достаточно для настоящего вечера. «Паруса» сделают остальное: вид на Петербург, живая музыка (чт–вс), авторская кухня.",
        "highlight": "День рождения без планов в «Парусах» — это иногда самый честный и живой праздник. Никакой подготовки, просто вы и Петербург за окном."
      },
      {
        "heading": "Звоните",
        "body": "+7 (812) 991-10-90. Ул. Марата, 5, 6-й этаж. Скидка 20% именинникам.",
        "list": [
          "+7 (812) 991-10-90",
          "Ул. Марата, 5, 6-й этаж",
          "Скидка 20% именинникам",
          "Будни: больше шансов на сегодня"
        ]
      }
    ],
    "cta": { "text": "Позвонить прямо сейчас", "href": "/den-rozhdeniya" }
  }
];
